module.exports = __webpack_public_path__ + "img/ace1.c3bcb35c.jpg";